import angular from 'angular';

let UserFactory = angular.module('User', [])
.factory('User', (AuthFactory) =>{
	'ngInject';

	/**
	 * Constructor, with class name
	 */
	function User(data){
		let self = this;

		self.premium = data.premium;
		self.role = data.role.display_name;
		self.permissions = [];
		Object.entries(data.role.perms).forEach(([key, value]) => {
			self.permissions.push(value.name);
		});
		self.userType = AuthFactory.USER_TYPES.USER;
		self.teamId = null;
		self.name = data.username;
		if(data.team_id){
			self.name = data.name;
			self.userType = AuthFactory.USER_TYPES.TEAM;
			self.teamId = data.team_id;
		}

		/* Get Name */
		self.getName = () =>{
			return self.name;
		};

		/* Check permission */
		self.canDo = (permission) => {
			return this.permissions.includes(permission);
		};

		/* If User is Team */
		self.isUserTypeTeam = () => {
			return this.userType === AuthFactory.USER_TYPES.TEAM;
		};

		/* if is specific team */
		self.isTeam = (teamId) => {
			return this.teamId == teamId;
		};

		/* Check if the user is premium */
		self.isPremium = () => {
			return this.premium === 1;
		};
	}

	/**
	 * Static method, assigned to class
	 * Instance ('this') is not available in static context
	 */
	User.build = (data) =>{
		return new User(data);
	};

	/**
	 * Return the constructor function
	 */
	return User;
}).name;

export default UserFactory;



// WEBPACK FOOTER //
// ./client/app/services/user.factory.js